export interface ProtectionDetailsExclusions {
  protectionDetailsExclusions: string[];
  protectionDetailsExclusionsTitle: string;
}
